import SyDialog from "../../../components/SyDialog";
import OtpInput from "../../auth/components/OtpInput";
import useDeactivateAccount from "../useDeactivateAccount";
import { targetSummary } from "../accountMappers";

const DeleteAccountDialog = ({ open, onClose, onDeactivated, onSignedOut }) => {
  const {
    targets,
    codes,
    setCode,
    message,
    starting,
    submitting,
    error,
    cooldown,
    expired,
    canResend,
    canSubmit,
    resend,
    submit,
    retry,
  } = useDeactivateAccount({
    active: open,
    onClosed: (result) => {
      if (result?.signedOut) return onSignedOut();
      if (result?.deactivated) return onDeactivated(result.message);
      return undefined;
    },
  });

  if (!open) return null;

  const summary = targetSummary(targets);

  return (
    <SyDialog
      open
      title="Delete account"
      subtitle="This closes your Sayagie account and signs you out everywhere."
      size="sm"
      className="acct-dialog"
      onClose={submitting ? () => {} : onClose}
      footer={
        <div className="acct-dialog-actions">
          <button
            type="button"
            className="sy-flow-btn sy-flow-btn-quiet"
            disabled={submitting}
            onClick={onClose}
          >
            Keep my account
          </button>

          <button
            type="button"
            className="sy-flow-btn sy-flow-btn-danger"
            disabled={!canSubmit}
            onClick={submit}
          >
            {submitting ? "Deleting…" : "Delete account"}
          </button>
        </div>
      }
    >
      {starting && <p className="acct-dialog-lede">Sending your codes…</p>}

      {!starting && !targets.length && (
        <div className="acct-dialog-fail">
          <p>{error || "We could not start the deletion. Please try again."}</p>

          <button type="button" className="sy-flow-link" onClick={retry}>
            Try again
          </button>
        </div>
      )}

      {!starting && targets.length > 0 && (
        <>
          <p className="acct-dialog-lede">
            {message ||
              (summary
                ? `We sent a verification code to ${summary}. Enter ${
                    targets.length > 1 ? "both codes" : "it"
                  } to confirm.`
                : "Enter the verification code we sent you to confirm.")}
          </p>

          <div className="acct-otp-stack">
            {targets.map((target, index) => (
              <OtpInput
                key={target.channel}
                id={`acct-otp-${target.channel}`}
                label={`${target.label} code${
                  target.masked ? ` · ${target.masked}` : ""
                }`}
                value={codes[target.channel]}
                onChange={(value) => setCode(target.channel, value)}
                disabled={submitting || expired}
                autoFocus={index === 0}
                invalid={Boolean(error)}
              />
            ))}
          </div>

          <div className="acct-dialog-foot">
            <button
              type="button"
              className="sy-flow-link"
              disabled={!canResend}
              onClick={resend}
            >
              {cooldown > 0 ? `Resend in ${cooldown}s` : "Resend code"}
            </button>
          </div>

          {error && <p className="sy-flow-note">{error}</p>}
        </>
      )}
    </SyDialog>
  );
};

export default DeleteAccountDialog;
